import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import Button from '@react/react-spectrum/Button'
import { TabView } from '@react/react-spectrum/TabView'
import { Tab } from '@react/react-spectrum/TabView'
import { Form, FormItem } from '@react/react-spectrum/Form'
import Textfield from '@react/react-spectrum/Textfield'
import Textarea from '@react/react-spectrum/Textarea'
import Heading from '@react/react-spectrum/Heading'
import Email from '@react/react-spectrum/Icon/Email'
import SMS from '@react/react-spectrum/Icon/SMS'
import CallCenter from '@react/react-spectrum/Icon/CallCenter'
import Well from '@react/react-spectrum/Well'
import { success } from '@react/react-spectrum/Toast'
import Wait from '@react/react-spectrum/Wait'

import { ProfileContext } from '../../../root/ProfileContext'
import { RootContext } from '../../../root/RootContext'

import './Contact.scss'

function pad(val) {
  return val > 9 ? val : '0' + val
}

export default function Contact({ meta, content }) {
  const profileContext = useContext(ProfileContext)
  const currentProfile = profileContext.state.currentProfile

  const rootContext = useContext(RootContext)
  const operator = rootContext.project.userContext

  const subject = `[CASE-${Math.round(Math.random() * 100)}]`
  const defaultMessage = "I'd like to follow up with you regarding...\n\n " + operator?.name + ' \n' + operator?.role
  const defaultSubject = subject + ' ' + currentProfile?.profile?.entity?.person?.name.firstName + ', your enquiry'

  const [values, setValues] = useState({
    subject: '',
    emailMessage: defaultMessage,
    smsMessage: defaultMessage,
    to: '',
  })

  const [callDetails, setCallDetails] = useState({ started: false, startTime: null, buttonLabel: 'Start Call' })
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    if (currentProfile) {
      const nb =
        'phone' in currentProfile?.profile?.entity?.identityMap
          ? currentProfile?.profile?.entity?.identityMap?.phone[0].id
          : 'mobilenb' in currentProfile?.profile?.entity?.identityMap
          ? currentProfile?.profile?.entity?.identityMap?.mobilenb[0].id
          : 'N/A'

      setValues({
        ...values,
        subject: defaultSubject,
        to: nb,
      })
    }
  }, [currentProfile])

  const handleChange = (k, e) => {
    setValues({ ...values, [k]: e })
  }

  useEffect(() => {
    if (callDetails.started) {
      var timerID = setInterval(() => setSeconds((s) => s + 1), 1000)
      return function cleanup() {
        clearInterval(timerID)
      }
    }
  }, [callDetails.started])

  return (
    <div className='profile-module contact'>
      <div className='module-content'>
        {currentProfile && (
          <div align='center'>
            {content.description && <Well>{content.description}</Well>}
            <TabView>
              <Tab key='email-form' label='Email' icon={<Email alt='Email' size='M' />}>
                <Heading size={3} id='email-form'>
                  Send an Email to {currentProfile?.profile?.entity?.person?.name.firstName || '-'}{' '}
                  {currentProfile?.profile?.entity?.person?.name.lastName || '-'}
                </Heading>

                <Form aria-labelledby='email-form'>
                  <FormItem label='Subject' labelAlign='right'>
                    <Textfield
                      value={values.subject}
                      name='subject'
                      key='subject'
                      className='subject'
                      onChange={(e) => handleChange('subject', e)}
                    />
                  </FormItem>

                  <FormItem label='Message' labelAlign='right'>
                    <Textarea
                      id='emailContent'
                      value={values.emailMessage}
                      name='emailMessage'
                      key='emailMessage'
                      className='message'
                      onChange={(e) => handleChange('emailMessage', e)}
                    />
                  </FormItem>

                  <FormItem labelAlign='right'>
                    <Button
                      name='sendMessage'
                      data-channel='email'
                      variant='primary'
                      icon={<Email />}
                      onClick={(e) => {
                        e.preventDefault()
                        e.target.dispatchEvent(
                          new CustomEvent('sendMessage', {
                            detail: {
                              channel: 'email',
                              to: currentProfile?.profile?.entity?.identityMap?.email[0].id,
                              content: document.getElementsByName('emailMessage')[0].innerHTML,
                              from: operator.name,
                              subject: document.getElementsByName('subject')[0].value,
                            },
                          })
                        )
                        success('Message sent to customer.', {
                          onClose: () => {},
                          timeout: 4000,
                        })
                      }}
                    >
                      Send
                    </Button>
                  </FormItem>
                </Form>
              </Tab>
              <Tab key='sms-form' label='SMS' icon={<SMS alt='SMS' size='M' />}>
                <Heading size={3} id='email-form'>
                  Send a SMS to {currentProfile?.profile?.entity?.person?.name.firstName || '-'}{' '}
                  {currentProfile?.profile?.entity?.person?.name.lastName || '-'}
                </Heading>

                <Form aria-labelledby='sms-form'>
                  <FormItem label='Mobile' labelAlign='right'>
                    <Textfield
                      name='to'
                      key='to'
                      className='subject'
                      value={values.to}
                      onChange={(e) => handleChange('to', e)}
                    />
                  </FormItem>
                  <FormItem label='Message' labelAlign='right'>
                    <Textarea
                      id='smsContent'
                      value={values.smsMessage}
                      name='smsMessage'
                      key='smsMessage'
                      className='message'
                      onChange={(e) => handleChange('smsMessage', e)}
                    />
                  </FormItem>

                  <FormItem labelAlign='right'>
                    <Button
                      name='sendMessage'
                      data-channel='sms'
                      variant='primary'
                      icon={<SMS />}
                      onClick={(e) => {
                        e.preventDefault()
                        e.target.dispatchEvent(
                          new CustomEvent('sendMessage', {
                            detail: {
                              channel: 'sms',
                              to: values.to,
                              content: document.getElementsByName('smsMessage')[0].innerHTML,
                              from: operator.name,
                            },
                          })
                        )
                        success('Message sent to customer.', {
                          onClose: () => {},
                          timeout: 4000,
                        })
                      }}
                    >
                      Send
                    </Button>
                  </FormItem>
                </Form>
              </Tab>
              <Tab label='Phone Call' icon={<CallCenter alt='CallCenter' size='M' />}>
                <Heading size={3} id='phone-form'>
                  Call {currentProfile?.profile?.entity?.person?.name.firstName || '-'}{' '}
                  {currentProfile?.profile?.entity?.person?.name.lastName || '-'}
                </Heading>
                <Form aria-labelledby='phone-form' style={{ minHeight: '350px' }}>
                  <div className='dialer'>
                    <div className='callButton'>
                      <Button
                        name='sendMessage'
                        data-channel='phone'
                        variant='primary'
                        onClick={(e) => {
                          e.preventDefault()
                          if (!callDetails.started) {
                            setSeconds(0)
                            setCallDetails({ ...callDetails, started: true, startTime: new Date().toLocaleString() })
                          } else {
                            setCallDetails({
                              ...callDetails,
                              started: false,
                              duration: seconds,
                            })

                            e.target.dispatchEvent(
                              new CustomEvent('sendMessage', {
                                detail: {
                                  channel: 'phone',
                                  to: values.to,
                                  content: callDetails.startTime,
                                  from: operator.name,
                                },
                              })
                            )
                            success('Call Details successfully logged.', {
                              onClose: () => {},
                              timeout: 4000,
                            })
                          }
                        }}
                        icon={<CallCenter />}
                      >
                        {callDetails.started ? 'Stop Call' : 'Start Call'}
                      </Button>

                      {callDetails.started && (
                        <Wait size='S' style={{ marginLeft: 10, verticalAlign: '-webkit-baseline-middle' }} />
                      )}
                    </div>
                    <div className='callDuration'>
                      Call Duration: {`${pad(parseInt(seconds / 60, 10))}:${pad(seconds % 60)}`}
                    </div>
                  </div>
                </Form>
              </Tab>
            </TabView>
          </div>
        )}
      </div>
    </div>
  )
}

Contact.requiresLaunch = true
